module.exports = __webpack_public_path__ + "img/c1.998df903.svg";